<nav class="tabs" role="tablist" [attr.aria-label]="ariaLabel">
  @for (tab of tabs; track tab.link; let index = $index) {
    <a
      class="tab"
      [class.active]="isActive(index)"
      [routerLink]="tab.link"
      role="tab"
      [attr.aria-selected]="isActive(index)"
      [attr.aria-current]="isActive(index) ? 'page' : null"
    >
      {{tab.label}}
    </a>
  }
</nav>
